import React, {JSX} from 'react';
import '../../css/views/navMenu.css';
import '../../css/components/subMenu.css';
import _ from 'underscore'
import {Badge} from "./Badge";
import Menu from "@mui/material/Menu";
import MenuItem from '@mui/material/MenuItem';
import classNames from "classnames";
import type {NavMenuItemType} from "../../views/nav-menu/NavMenuSubmenuListItem";
import {ListItemText} from "@mui/material";

export type SubMenuProps = {
  id: string,
  activeSubMenuItemPath: string,
  anchorEl: null | HTMLElement,
  buyerSpaceUsageRedesign: boolean,
  handleLogout: (event: React.MouseEvent) => void,
  menuItem: NavMenuItemType,
  menuItemIndex: number,
  menuTotalItems: number,
  onSubMenuItemClick: (path: string) => void,
  show: boolean,
  onClose: (event: React.MouseEvent) => void,
  MenuListProps: Object
};

const SubMenu: (props: SubMenuProps) => JSX.Element = (
  props
) => {
  return (
    <Menu id={props.id} open={props.show} onClose={props.onClose} anchorEl={props.anchorEl}
          MenuListProps={props.MenuListProps}>
      {
        _.map(props.menuItem.submenus ?? [], (subMenuItem: NavMenuItemType) =>
          <MenuItem
            key={subMenuItem.path}
            onClick={() => props.onSubMenuItemClick(subMenuItem.path)}
            className={classNames("ss-nav-drop-down-menu", props.activeSubMenuItemPath === subMenuItem.path ? "ss-drop-down-active" : "ss-dropw-down-inactive")}
          >
            {
              <ListItemText>
                  <span className={subMenuItem.highlighted ? "ss-nav-menu-item-highlighted" : ""}>
                    {props.buyerSpaceUsageRedesign && subMenuItem.label === 'Booked Space Calendar'
                      ? 'Space Usage' : subMenuItem.label}
                  </span>
              </ListItemText>
            }
            {
              <Badge
                isPadding
                static
                menuItem={subMenuItem}
              />
            }
          </MenuItem>
        )
      }
    </Menu>
  );
}

export default SubMenu;
